"use strict";module.exports = {
  setExpandedState(isExpanded) {
    if (isExpanded !== this.state.expanded) {
      this.state.expanded = isExpanded;
      if (isExpanded) {
        this.emit('expanded');
      } else {
        this.emit('collapsed');
      }
    }
  },

  handleExpand() {
    this.setExpandedState(!this.state.expanded);
  },

  handleScroll() {
    this.setExpandedState(true);
  },

  handleTouchStart(event) {
    var touches = event.changedTouches;
    this.touches = Array.prototype.map.call(touches, function (_ref) {var identifier = _ref.identifier,pageY = _ref.pageY;return {
        identifier,
        pageY };});

  },

  handleTouchMove(event) {var _this = this;
    if (this.touches.length) {
      event.changedTouches.forEach(function (current) {
        var compare = _this.touches.findIndex(
        function (item) {return item.identifier === current.identifier;});

        var diff = current.pageY - _this.touches[compare].pageY;

        if (diff > 30) {
          // Drag down, collpase
          if (_this.state.expanded) {
            _this.setExpandedState(false);
          } else {
            _this.getComponent('dialog').state.open = false;
          }
          _this.handleTouchEnd(event);
        } else if (diff < -30) {
          _this.setExpandedState(true);
          _this.handleTouchEnd(event);
        }
      });
    }
  },

  handleTouchEnd(event) {var _this2 = this;
    event.changedTouches.forEach(function (current) {
      var idx = _this2.touches.findIndex(function (item) {return item.identifier === current.identifier;});
      if (idx > -1) {
        _this2.touches.splice(idx, 1);
      }
    });
  },

  onMount() {
    this.touches = [];
  },

  onInput(input) {
    this.state = { expanded: input.expanded || false };
  } };